<template>
  <b-row class="d-flex flex-wrap pt-3 pl-2">
    <b-card v-if="isShow" class="mr-2" no-body v-for="( item, index ) in tableData" :key="index" style="width: 187px;">
      <b-card-img
              style="height: 139px;"
              :src="item.templateImage?item.templateImage:'/image/static/img/nopic.jpg'"
      ></b-card-img>
      <div class="mt-1">
        <span class="card-title">{{item.templateName}}</span>
      </div>
      <div class="mt-1" style="text-align:right;">
        <b-button variant="outline-success" size="sm" @click="handleCurrentChange(item)">
          {{$l('dialog_ppt_table_btn_choice')||'选择此模板'}}
        </b-button>
      </div>
    </b-card>
    <b-col v-if="!isShow">
      <div style="text-align:center;">
        <b-img src="/image/static/img/nodata.png" />
        <p class="no-data">{{$l('INDEX.tips_no_data')||'暂无数据！'}}</p>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    },
    isShow: {
      default: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
    handleCurrentChange (val) {
      this.$confirm(this.$l('tips_select_template')|| '是否使用该模板？', this.$l('INDEX.tips_question_title')||'提示', {
        confirmButtonText: this.$l('INDEX.tips_confirm')||'确定',
        cancelButtonText: this.$l('INDEX.tips_cancel')||'取消',
        type: 'warning'
      }).then(() => {
        this.$emit('currentChange', val)
      }).catch(() => {})
    }
  }
}
</script>
